// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1__d00e1737a5b085809be4","cls2":"common-cls2___b04e7a9656784395256 common-cls1__d00e1737a5b085809be4"};